import { Link } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import type { IAdviceCardProps } from './IAdviceCardProps';

/** Картка поради (прототип v4): тон за важливістю (червоний — висока, жовтий — середня, нейтральний — низька), текст і кнопка дії. */
export function AdviceCard({ item, text, action }: IAdviceCardProps) {
  return (
    <div className={cx('mp-advice', item.level === 'high' && 'is-high', item.level === 'mid' && 'is-mid')}>
      <span>{text}</span>
      {action && <Link className="mp-advice__act" to={action.to}>{action.label}</Link>}
    </div>
  );
}
